import mixpanel from 'mixpanel-browser/src/loaders/loader-module-with-async-recorder';

Wahanda.SessionReplay = {
  init: function (key) {
    if (App.isMasquerading() || !Wahanda.Features.isEnabled('mixpanel-session-replays')) {
      // Do not track masqueraded users
      return;
    }
    const self = this;
    try {
      mixpanel.init(key, {
        record_sessions_percent: 0, // Setting this to 0 disables automatic session recording when initializing mixpanel
        record_idle_timeout_ms: 600000, //End a replay capture after 10 mins of inactivity
        record_heatmap_data: false,
        record_mask_text_selector: '', // remove masked text
        loaded: function () {
          // verify if session is in progress and stop it
          // close the session after initial load (page refresh)
          self.stopIfSessionInProgress();
        },
      });
    } catch (e) {
      console.log('Issue with initializing mixpanel session: ' + e.message);
    }
  },
  startRecording: function () {
    if (App.isMasquerading() || !Wahanda.Features.isEnabled('mixpanel-session-replays')) {
      return;
    }
    try {
      // An explicitly requested recording must not be killed by the
      // page-load cleanup polling in stopIfSessionInProgress
      this.recordingRequested = true;
      this.cancelStopPolling();
      mixpanel.start_session_recording();
    } catch (e) {
      console.log('Starting session recording issue: ' + e.message);
    }
  },
  stopRecording: function () {
    if (App.isMasquerading() || !Wahanda.Features.isEnabled('mixpanel-session-replays')) {
      return;
    }
    try {
      mixpanel.stop_session_recording();
    } catch (e) {
      console.log('Stopping session replay recording issue: ' + e.message);
    }
  },
  identifyUser: function (userId) {
    if (App.isMasquerading() || !Wahanda.Features.isEnabled('mixpanel-session-replays')) {
      return;
    }
    try {
      mixpanel.identify(userId);
    } catch (e) {
      console.log('Issue with identifying user: ' + e.message);
    }
  },
  /**
   * Checks if the venue was created (signed up for Connect) within the
   * last `days` days — a rolling window measured back from now at
   * timestamp precision, so a venue ages out mid-day. Fails closed: a
   * missing or unparseable venue creation date makes the venue ineligible.
   */
  isVenueSignedUpWithinLastDays: function (days) {
    const venue = App.config && App.config.get('venue');
    if (!venue || !venue.created) {
      return false;
    }
    const created = new Date(venue.created).getTime();
    if (isNaN(created) || typeof days !== 'number' || isNaN(days)) {
      return false;
    }
    const windowStart = Date.now() - days * 24 * 60 * 60 * 1000;
    return created >= windowStart;
  },
  /**
   * Method that verifies if session recording is in progress by checking
   * if $mp_replay_id is available and stopping the session recording.
   * This is specifically useful in the case when we want to stop the recording
   * after the page refresh.
   * Replay id needs time to load so we do a polling check to verify if present.
   */
  stopIfSessionInProgress: function () {
    const self = this;
    const maxRetryCount = 10;
    let retryCount = 0;
    if (this.recordingRequested) {
      return;
    }
    this._stopPollingInterval = setInterval(function () {
      retryCount++;
      if (retryCount === maxRetryCount) {
        self.cancelStopPolling();
      }
      if (self.recordingRequested) {
        self.cancelStopPolling();
        return;
      }
      const mixpanelProps = mixpanel.get_session_recording_properties();
      // having $mp_replay_id we can assume that recording is in progress
      if (mixpanelProps && !!mixpanelProps.$mp_replay_id) {
        self.stopRecording();
        self.cancelStopPolling();
      }
    }, 100);
  },
  cancelStopPolling: function () {
    if (this._stopPollingInterval) {
      clearInterval(this._stopPollingInterval);
      this._stopPollingInterval = null;
    }
  },
};
